<template>
  <div class="home">
    <!-- <Header :firstLink="'/plan'" /> -->
    <HeaderCuotas :data="headerData" />
    <Menu />
    <p class="info">
      - Nota 1: Se podrá comercializar el Plan BÁSICO SIN Aporte Complementario Mensual (ACM) en todas las delegaciones.<br>
      - Nota 2: Las opciones que estén entre el valor neto del Monotributo Categoría A-B-C ($ 15.045) y el mínimo del Plan Básico y Los Monotributos sin ACM, ingresan al Plan Azul en aquellas Delegaciones habilitadas para tal fin. Los demás casos ingresan al Plan Visitar.<br>
      - Nota 3: Monotributistas con Aporte Complementario Mensual y Adherentes podrán ser captados en aquellas delegaciones que estén habilitadas para hacerlo.<br>
      - Nota 4: No tomar Opciones con una cápita por debajo de los $ 15.045 (valor neto Monotributo Categoría A-B-C).<br>
      - Nota 5: En caso de optar por el pago por débito automático con tarjeta de crédito, se otorgará un descuento sobre el Aporte Complementario Mensual del 5%. En caso de optar por el pago en efectivo del semestre anticipado, se otorgará igual descuento manteniendo congelado el valor inicial del Aporte Complementario Mensual calculado según sueldo y composición del grupo familiar.<br>
      - Nota 6: Los Adherentes que optaren por pagar semestre anticipado, gozarán también de un descuento del 5% sobre el valor de la cuota que quedará congelada para el plan elegido y la composición del grupo familiar.<br>
      - Nota 7: No se aceptarán débitos automáticos con Tarjeta de Débito, Cajas de Ahorros o Cuenta Corriente. Solo se aceptan débitos automáticos en Tarjetas de Crédito.<br>
      - Nota 8: En cada plan hay celdas con valor CERO. En dicho plan y la categoría de Monotributo correspondiente, no paga ACM.<br>

    </p>
    <Footer />
   
  </div>
</template>

<script>

import Menu from "../components/cuotas/Menu";
import HeaderCuotas from "../components/header/HeaderCuotas";
import Footer from "../components/footer/Footer";

export default {
  name: "Home",
  components: {
    
    Menu,
    HeaderCuotas,
    Footer,
  },
  metaInfo: {
    title: "Inicio",
  },
  created() {
    window.scroll(0, window.innerHeight);
  },
  data() {
    return {
      headerData: {
        logo: "home",
        menu: [
          { type: "to", to: "/plan", text: "Ver planes" },
          {
            type: "href",
            href: "https://www.osfatun.com.ar/",
            text: "Ir al sitio web",
          },
        ],
      },
    };
  },
};
</script>

<style scoped>
.info {
  font-size: 14px;
  max-width: 80%;
  margin: 0 auto;
}
</style>
